var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('PlanSelection',{attrs:{"loading":_vm.loading,"plans":_vm.currentlyShownPlans,"billing-model":_vm.billingModel},on:{"changeBillingModel":_vm.handleChangeBillingModel,"purchasePlan":_vm.redirectToPlanManagement}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }